import { CountryConfig } from '../types/apiConfig';
import { useSelector } from 'react-redux';
import { countryConfigSelector } from '../redux/reducers/countryConfigReducer';
import { useCallback } from 'react';

export function useGetCountryConfig(): (country: string) => CountryConfig {
  const countryConfigs = useSelector(countryConfigSelector);
  return useCallback(
    (country: string) => {
      const config = countryConfigs.find((c) => c.countryIso === country);
      return config ?? countryConfigs.find((c) => c.countryIso === 'default')!;
    },
    [countryConfigs]
  );
}
